export function Footer() {
  return (
    <footer className="no-print mt-16 flex items-center justify-center bg-black px-8 py-8 text-white">
      <p>Sistema Iguatermar - 2025</p>
    </footer>
  )
}
